export default __webpack_public_path__ + "static/media/gb-sct.c89e406d.svg";